import { LatLng } from "leaflet";
import { useState } from "react";
import { useMapEvents, Circle } from "react-leaflet";

interface CircleDrawProps {
  onDraw: (center: LatLng, radius: number) => void;
}

const CircleDrawTool = ({ onDraw }: CircleDrawProps) => {
  const [center, setCenter] = useState<LatLng>();
  const [radius, setRadius] = useState<number>();

  useMapEvents({
    click(e) {
      if (center && radius !== undefined) {
        onDraw(center, radius);
        setCenter(undefined);
        setRadius(undefined);
        return;
      }
      setCenter(e.latlng);
    },
    mousemove(e) {
      if (center) {
        const r = center.distanceTo(e.latlng);
        setRadius(r);
      }
    },
  });

  return center && radius !== undefined ? <Circle center={center} radius={radius} /> : null;
};

export default CircleDrawTool;
